import debug from "src/modules/debug-logger";
import { Type } from "src/modules/media-upload-protobuf";

const DATA_BUFFER_LENGTH = 500;

export default async function uploadData({ ws, media }) {
  let currentBufferIndex = 0;

  const bufferSize = media.rawData.length;
  const numberOfFullBuffers = Math.floor(bufferSize / DATA_BUFFER_LENGTH);
  const lastBufferSize = bufferSize - numberOfFullBuffers * DATA_BUFFER_LENGTH;
  debug.activityLog("Buffer size", bufferSize);

  function sendDataMessage(data) {
    const message = Type.Message.create({
      dataMessage: Type.DataMessage.create({ data })
    });
    ws.send(Type.Message.encode(message).finish());
  }

  for (
    currentBufferIndex;
    currentBufferIndex < numberOfFullBuffers;
    currentBufferIndex++
  ) {
    const bufferToSend = new Uint8Array(DATA_BUFFER_LENGTH);

    bufferToSend.set(
      media.rawData.slice(
        currentBufferIndex * DATA_BUFFER_LENGTH,
        (currentBufferIndex + 1) * DATA_BUFFER_LENGTH
      )
    );
    sendDataMessage(bufferToSend);
  }

  if (lastBufferSize > 0) {
    const bufferToSend = new Uint8Array(lastBufferSize);

    bufferToSend.set(
      media.rawData.slice(
        currentBufferIndex * DATA_BUFFER_LENGTH,
        currentBufferIndex * DATA_BUFFER_LENGTH + lastBufferSize
      )
    );
    sendDataMessage(bufferToSend);
  }

  debug.activityLog(`finished uploading file ${media.fileName}`);
}
